import { Container, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Contact } from "../components/contact"
import { Layout } from "../components/layout"
import { Head } from "../components/seo"

export const LocationsPage = () => {
  const { t } = useTranslation("translations", { keyPrefix: "LOCATIONS" })

  return (
    <Layout title="LOCATIONS" subtitle={t("SUBTITLE")}> 
      <Head title="LOCATIONS" />
      <Container>
        <Row className="my-5">
          <Col md="12">
            <h2 className="text-center">{t("NAGOYA.TITLE")}</h2>
            <p className="text-center">{t("NAGOYA.ADDRESS_1")}</p>
            <p className="text-center">{t("NAGOYA.ADDRESS_2")}</p>
          </Col>
        </Row>
        <Row className="my-5">
          <Col md="12">
            <h2 className="text-center">{t("TAIWAN.TITLE")}</h2>
            <p className="text-center">{t("TAIWAN.ADDRESS_1")}</p>
            <p className="text-center">{t("TAIWAN.ADDRESS_2")}</p>
          </Col>
        </Row>
      </Container>
      <Contact />
    </Layout>
  )
}
